const activePlayer = () => {
  return useState<number | null>('activePlayer', () => null)
}

const stateCompact = () => {
  return useState('compact', () => ref(false))
}

export function useTournamentHelpers() {
  const activePlayerId = activePlayer()
  const compact = stateCompact()

  return {
    activePlayerId,
    compact,
  }
}
